<template>
  <div class="ongoing-page">
    <AppHeader
      title="Inspectie nog bezig"
      :show-back-button="true"
      back-to="/rapporten"
      back-text="Terug naar rapporten"
    />

    <section class="ongoing-card">
      <p class="ongoing-label">Inspectie in uitvoering</p>
      <h2 class="ongoing-title">{{ inspectieLabel || "Inspectie" }} is nog niet afgerond</h2>
      <p class="ongoing-description">
        De details van dit rapport zijn pas beschikbaar nadat de initiële inspectie is afgerond. Zodra de inspecteur
        dit inspectietype afrondt, kunt u hier verder met de rapportdetails en eventuele herstelstappen.
      </p>
    </section>

    <!-- Pre-inspection document checklist: the "documenten opgevraagd" email links
         here (via /rapport/:id) while the inspectie is still ongoing, so the
         opdrachtgever must be able to upload the requested documents on this page. -->
    <DocumentVereistenSection
      v-if="rapportId"
      class="vereisten-section"
      :rapport-id="rapportId"
      :active-inspectie-type="inspectieType"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  import AppHeader from "../components/AppHeader.vue";
  import DocumentVereistenSection from "../components/DocumentVereistenSection.vue";
  import { getInspectieTypeParam } from "../utils/rapportScope";
  import { inspectieTypeLabels } from "../../../../types";

  const route = useRoute();

  const rapportId = computed(() => (typeof route.query.id === "string" ? route.query.id : ""));
  const inspectieType = computed(() => getInspectieTypeParam(route.query.type));
  const inspectieLabel = computed(() => {
    if (!inspectieType.value) return "";
    return inspectieTypeLabels[inspectieType.value] || inspectieType.value;
  });
</script>

<style scoped>
  .ongoing-page {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-bottom: 2rem;
  }

  .ongoing-card {
    border-radius: 0.75rem;
    border: 1px solid var(--p-background-200);
    background: linear-gradient(145deg, var(--p-background-0), var(--p-background-50));
    padding: 2rem;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
    max-width: 48rem;
  }

  .ongoing-label {
    margin: 0 0 0.75rem;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--p-primary-500, #3b82f6);
  }

  .ongoing-title {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--p-background-900);
  }

  .ongoing-description {
    margin: 1rem 0 0;
    line-height: 1.7;
    color: var(--p-background-700);
    max-width: 40rem;
  }

  .vereisten-section {
    max-width: 48rem;
  }
</style>
